module.exports = __webpack_public_path__ + "static/media/ktl.5ec57b1e.5ec57b1e.jpg";